import './styles';

import {useCallback, useMemo} from 'react';

import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {AppButton, AppButtonVariant} from '@/app/shared-components';

import {
  SplitsViewModelProvider,
  useSplitBillsViewModelProvider,
} from './SplitsViewModelContext';

function SplitsErrorContent() {
  const {inviterName, onGetAvatarImage} = useSplitBillsViewModelProvider();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isNotFoundError = useMemo(
    () => location.state?.errorStatus === 404,
    [location.state?.errorStatus],
  );

  const title = useMemo(
    () =>
      isNotFoundError
        ? t('split_bills_page.error.not_available')
        : t('split_bills_page.error.title'),
    [isNotFoundError, t],
  );

  const description = useMemo(
    () =>
      isNotFoundError
        ? t('split_bills_page.error.not_available_description')
        : t('split_bills_page.error.description'),
    [isNotFoundError, t],
  );

  const handleTryAgain = useCallback(() => {
    navigate(`/splits?${searchParams.toString()}`, {replace: true});
  }, [navigate, searchParams]);

  return (
    <section
      className="splits-landing "
      style={{
        paddingLeft: 16,
        paddingRight: 16,
      }}>
      <Box className="splits-landing-container">
        <Box className="splits-landing-logo">
          <Box className="logo-container">
            <PaymentLinkLogo />
          </Box>
        </Box>
        <Box className="mt-24">{onGetAvatarImage(inviterName)}</Box>
        <Typography
          className="splits-confirmation-greeting mb-8"
          component="h1">
          {title}
        </Typography>
        <Typography className="splits-landing-description">
          {description}
        </Typography>

        {!isNotFoundError && (
          <Box className="mt-32 w-full">
            <AppButton
              id="splits-error-try-again"
              onClick={handleTryAgain}
              label={t('split_bills_page.error.try_again')}
              variant={AppButtonVariant.onPrimary}
            />
          </Box>
        )}
      </Box>
    </section>
  );
}

const SplitsErrorPage = () => (
  <SplitsViewModelProvider>
    <SplitsErrorContent />
  </SplitsViewModelProvider>
);

export default SplitsErrorPage;
